import React, { useState } from "react";
import GiftVoucherList from "routes/gift_vouchers/GiftVoucherList";
import api from "utils/api";
import { toast } from "react-toast";

const GiftVouchers = () => {
  const [syncLoading, setSyncLoading] = useState(false);

  const handleSyncCatalog = async () => {
    try {
      setSyncLoading(true);
      const response = await api.get(
        "https://billpay.mtmpay.in/Admin/api/update-gift-voucher-cron"
      );
      const { updated, new: newData, total_processed } = response.data;
      toast.success(
        `Catalog Synced: ${total_processed} processed (${newData} new, ${updated} updated)`
      );
    } catch (error) {
      toast.error("Failed to sync voucher catalog with provider.");
    } finally {
      setSyncLoading(false);
    }
  };

  return (
    <div className="gift-vouchers-page-wrapper">
      <GiftVoucherList
        onSyncCatalog={handleSyncCatalog}
        syncLoading={syncLoading}
      />
    </div>
  );
};

export default GiftVouchers;